import { createContext } from "react";

const MotionContext = createContext();

export default MotionContext;
